import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiToolbar, { ToolbarClassKey as MuiToolbarClassKey } from "@material-ui/core/Toolbar";

export type ToolbarClassKey = MuiToolbarClassKey;

export interface ToolbarProps extends StandardProps<React.HTMLAttributes<HTMLDivElement>, ToolbarClassKey> {
    variant?: 'regular' | 'dense';
    disableGutters?: boolean;
}

class Toolbar extends React.PureComponent<ToolbarProps> {
    render() {
        const { ...props } = this.props;
        return <MuiToolbar {...props}>
            {this.props.children}
        </MuiToolbar>;
    }
}

export default Toolbar;